// LM 360
export const SET_ACTIVE_THREE_SIXTY_COMPONENT = "SET_ACTIVE_THREE_SIXTY_COMPONENT";
export const SET_ACTIVE_INSTANCE_NAME = "SET_ACTIVE_INSTANCE_NAME";
